module.exports = __webpack_public_path__ + "images/kihnu/favicon-96x96.png";